import compact from 'lodash/compact';
import { mapToAdobeDataLayerProduct, normalizeString } from '@yme/utils/common';
import { getPdpLinkByCategory, getProductURL } from '@yme/utils/product';
import { PRIMARY_IMAGE_KEY } from './constants';
export const mapImageData = (data, imageData) => {
    const primaryImagePath = data.primaryImage?._path ?? '';
    const mapKeys = {
        [primaryImagePath]: PRIMARY_IMAGE_KEY,
    };
    const mappedImages = Object.entries(imageData).reduce((acc, [key, value]) => {
        const entryKey = mapKeys[key] || key;
        return {
            ...acc,
            [entryKey]: value,
        };
    }, {});
    return {
        ...data,
        expAssets: compact(data.expAssets.map((asset) => mappedImages[asset._path] && mappedImages[asset._path])),
        primaryImage: mappedImages.primaryImage,
    };
};
const mapDestinationAnalyticsData = (data, withUrl, edpPath) => {
    const slug = data._path.split('/').at(-1);
    const url = edpPath
        ? getProductURL({
            path: edpPath,
            isInAuthor: false,
            slug,
        })
        : '';
    const expLabels = Array.isArray(data.expLevel) ? data.expLevel : [data.expLevel];
    const expTypeArr = Array.isArray(data.expType) ? data.expType : [data.expType];
    return {
        id: normalizeString(slug),
        title: data.expTitle,
        country: normalizeString(data.expLocation.join(',')),
        category: expTypeArr.map((l) => normalizeString(l)).join(', '),
        level: expLabels.map((l) => normalizeString(l)).join(', '),
        price: parseFloat(data.expPrice.toFixed(2)),
        partner: normalizeString(data?.partnerReference?.partnerName),
        ...(withUrl
            ? {
                url,
            }
            : {}),
    };
};
const mapRelatedUnitsAnalytics = (data, pdpLinks) => {
    return data.map((item) => {
        const pdpUrl = getPdpLinkByCategory(pdpLinks, item.categories);
        return {
            product: mapToAdobeDataLayerProduct(item, pdpUrl),
        };
    });
};
export const getDestinationAnalyticsData = (data, units, pdpLinks) => {
    const destinationListing = data.relatedExperiences.map((item) => ({
        destination: mapDestinationAnalyticsData(item, true, data.edpPath),
    }));
    return {
        destination: mapDestinationAnalyticsData(data),
        destinationListing,
        unitListing: mapRelatedUnitsAnalytics(units, pdpLinks),
    };
};
